module.exports = __webpack_public_path__ + "static/futuro-bg-fb2e9aa6567836b8f409805af7ce81e1.jpg";